import { render, staticRenderFns } from "./channelPackage.vue?vue&type=template&id=79f0ccb4&"
import script from "./channelPackage.vue?vue&type=script&lang=js&"
export * from "./channelPackage.vue?vue&type=script&lang=js&"
import style0 from "./channelPackage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports